// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1GryY","Label":"Input_Label__3kZkM","InputElement":"Input_InputElement__2HaUE","Button":"Input_Button__2qw17","Invalid":"Input_Invalid__2XjrZ"};